
import { Translation, TranslationCreateFormValues, TranslationEditFormValues, TranslationRow } from "./types";

/*---------------------------------------------------------------------------------------
    TRANSLATION 
-----------------------------------------------------------------------------------------*/
export const transformTranslation = (formValues: Translation): any => {

  return {
    key: formValues.key,
    value: formValues.value,
  };
};

/*---------------------------------------------------------------------------------------
    TRANSLATION SEARCH
    -----------------------------------------------------------------------------------------*/

export const transformTranslationRow = (formValues: TranslationRow): any => ({
  id: formValues.id,
  key: formValues.key,
  value: formValues.value,
  created: formValues.created,
});

/*---------------------------------------------------------------------------------------
  TRANSLATION CREATE
-----------------------------------------------------------------------------------------*/

export const transformTranslationCreate = (
  formValues: TranslationCreateFormValues
): any => ({
  translationLanguageId: formValues.translationLanguageId,
  key: formValues.key,
  value: formValues.value,
});

/*---------------------------------------------------------------------------------------
    TRANSLATION UPDATE
-----------------------------------------------------------------------------------------*/

export const transformTranslationOnUpdate = (
  formValues: TranslationEditFormValues
): any => ({
  key: formValues.key,
  value: formValues.value,
});
